import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-20 min-h-[70vh] flex items-center justify-center bg-background-50 px-4"
      >
        <div className="text-center"
        >
          <h1 className="text-8xl md:text-9xl font-black text-background-200 select-none"
          >
            404
          </h1>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-2"
          >
            页面找不到了
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-md mx-auto"
          >
            您访问的页面可能已被移动、删除，或者从未存在过。让我们带您回到漫画世界吧。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center"
          >
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg text-sm font-semibold transition-colors"
            >
              <i className="ri-home-line" />
              返回首页
            </Link>
            <Link
              to="/category"
              className="inline-flex items-center gap-2 border border-foreground-300 text-foreground-700 hover:text-foreground-900 hover:border-foreground-400 px-6 py-3 rounded-lg text-sm font-medium transition-colors"
            >
              <i className="ri-book-open-line" />
              浏览漫画
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}